import { LinkButton } from 'src/components/atoms';
import styled from 'styled-components';

export const SlackButtonContainer = styled.div`
  display: flex;
  justify-content: right;
  align-items: center;
`;

export const CopySlackContainer = styled.div`
  margin-left: 5px;
`;

export const SlackInstallContainer = styled.div<{ hasInstalled: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: ${(props) => (props.hasInstalled ? 'end' : 'center')};
`;

export const BorderlessLinkButton = styled(LinkButton)`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: max-content;
  margin: 0;
  border: none;
  border-radius: 0;
  border-right: 1px solid
    ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N400
        : props.theme.atlas.core.color.gray[400]};
`;

export const LinkButtonWithCopyContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: right;
  border: 1px solid
    ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N400
        : props.theme.atlas.core.color.gray[400]};
  border-radius: 3px;
  font-family: 'rubik';
  width: 100%;

  max-width: 300px;

  @media screen and (max-width: 900px) {
    max-width: 100%;
  }
`;

export const WorkspaceName = styled.span`
  font-weight: 600;
`;

export const ButtonText = styled.div``;
